<template>
  <div>
    <div class="section-one">
      <div class="banner">
        <div class="slide">
          <img src="@/assets/images/banner_1.jpg" alt />
        </div>
      </div>
      <div class="section-one-con">
        <div class="section-container">
          <div class="title">
            <img src="@/assets/images/text_geju.png" alt="格局去，决定你的高度" title="格局去，决定你的高度" />
          </div>
          <div class="play">
            <a
              class="pause-play"
              target="_blank"
              href="http://geju.oss-cn-shanghai.aliyuncs.com/upload/20190705/20190705123455_5090.mp4"
            >
              <img src="@/assets/images/icon_play.png" alt />
            </a>
          </div>
          <div class="art">
            <div class="download">
              <div class="apple">
                <a
                  target="_blank"
                  href="https://itunes.apple.com/cn/app/ge-ju/id1136970653?mt=8&ign-mpt=uo%3D4"
                  class="btn btn1"
                >
                  <img src="@/assets/images/appledownload.png" alt />
                </a>
              </div>
              <div class="android">
                <a
                  target="_blank"
                  href="http://sj.qq.com/myapp/detail.htm?apkName=app.yy.geju"
                  class="btn btn2"
                >
                  <img src="@/assets/images/Androiddownload.png" alt />
                </a>
              </div>
            </div>
            <div class="code">
              <img src="@/assets/images/download_code.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionOne"
};
</script>

<style lang="css" scoped>
.banner {
  position: absolute;
  left: 0;
  top: 0;
}
.slider {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.slide img {
  width: 100%;
  height: 100%;
}
.section-one-con {
  width: 50%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 0;
  z-index: 1;
  transform: translateX(-50%);
}
.section-container {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.title {
  width: 557px;
  height: 51px;
  margin-top: 106px;
  margin-left: -20px;
}
.title img {
  width: 100%;
  height: 100%;
  opacity: 0;
}
.title.current img {
  animation: myFirst 2s;
  animation-fill-mode:forwards;
}
@keyframes myFirst {
  0%{
    transform: translateX(-1288px);
    opacity: 0;
  }
  100%{
    transform: translateX(0);
    opacity: 1;
  }
}
.play {
  width: 100%;
  height: 350px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pause-play {
  display: block;
  width: 50px;
  height: 50px;
  padding-left: 50px;
  cursor: pointer;
}
.pause-play img {
  width: 50px;
  height: 50px;
}
.art {
  width: 100%;
  height: 215px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top:60px;
}
.art .download {
    width:18%;
    align-self:center;
    display:flex;
    justify-content: space-between;
    align-items:center;
    flex-direction:column;
}
.art .download div{
    width: 116px;
	  height: 39px;
    display:flex;
    justify-content: space-around;
    align-items:center;
    box-sizing:border-box;
    margin:18px;
}
.btn{
    font-size:14px;
    color:#fff;
}
.btn:hover{
  color:#38adff;
}
.btn i{
    /* display:inline-block; */
    width:22px;
    height:22px;
    color:#fff;
    padding-right:15px;
}

</style>
